import { render, staticRenderFns } from "./Collaborateurs.vue?vue&type=template&id=26cd687c&"
import script from "./Collaborateurs.vue?vue&type=script&lang=js&"
export * from "./Collaborateurs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports